export const ActionWizard = {
  "defaultAction": {
    "prePareForDistribution": {
      "actionName": "Prepare For Distribution",
      "panelName": "Clean Up",
      "description": "Be sure hidden information is removed and documents are branded with appropriate watermarks, headers, or footers before distributing.",
      "instructions": "Use these tools to brand documents before distributing."
    },
    "makeAccessible": {
      "actionName": "Make Accessible",
      "panelName": "1. Prepare",
      "description": "Make your PDF accessible to audiences using Foxit PDF Editor accessibility tools. These steps will help scanned text, content structure and document information be available for assistive technology."
    },
    "publishSensitiveInformation": {
      "actionName": "Publish Sensitive Information",
      "description": "Redact sensitive content, remove hidden information and add password protection if needed.",
      "redactRemoveReduce": "1. Redact, Remove & Reduce",
      "instructions1": "Use \"Mark for Redaction\" to mark additional text and images for removal. When finished \"Apply Redactions\" will permanently remove marked information.",
      "passwordProtect": "Password Protect",
      "instruction2": "This step allows you to require a password when opening the document and restrict editing and printing."
    },
    "optimizeScannedDocuments": {
      "actionName": "Optimize Scanned Documents",
      "description": "Make scanned documents more useful by converting their contents into searchable text, correcting page orientation, and reducing file size.",
      "panelName": "Enhance",
      "instruction": "These steps make scanned documents more useful by converting content to searchable text, correcting page orientation, and reducing file size."
    }
  },
  "createAction": {
    "Modal": {
      "createTitle": "Create New Action",
      "editTitle": "Edit Action",
      "saveAction": "Save Action",
      "actionName": "Action Name",
      "untitled": "Untitled",
      "actionDescription": "Action Description",
      "cancel": "Cancel",
      "save": "Save",
      "ok": "Ok",
      "addOrEditLabel": "Add Or Edit Label",
      "panelName": "Panel Name",
      "instructions": "Instructions",
      "pause": "Pause",
      "chooseTools": {
        "title": "Choose tools to add:",
        "tree": {
          "comment": "Comment",
          "typewriter": "Typewriter",
          "stamps": "Stamps",
          "addStamp": "Add Stamp",
          "form": "Form",
          "detectFormFields": "Detect Form Fields",
          "protect": "Protect",
          "redaction": "Redaction",
          "applyRedactions": "Apply Redactions",
          "secureDocument": "Secure Document",
          "hiddenData": "Hidden Data",
          "removeHiddenInformation": "Remove Hidden Information",
          "passwordProtect": "Password Protect",
          "convert": "Convert",
          "recognizeText": "Recognize Text",
          "organize": "Organize",
          "pageMarks": "Page Marks",
          "addBackground": "Add Background",
          "addBatesNumbering": "Add Bates Numbering",
          "addHeaderFooter": "Add Header & Footer",
          "addWatermark": "Add Watermark",
          "removeBackground": "Remove Background",
          "removeBatesNumbering": "Remove Bates Numbering",
          "removeHeaderFooter": "Remove Header & Footer",
          "removeWatermark": "Remove Watermark",
          "pages": "Pages",
          "deletePages": "Delete Pages",
          "extractPages": "Extract Pages",
          "insertBlankPages": "Insert Blank Pages",
          "replacePages": "Replace Pages",
          "rotatePages": "Rotate Pages",
          "moreTools": "More Tools",
          "executeJavascript": "Execute JavaScript",
          "file": "File",
          "mainPanel": "Main Panel",
          "print": "Print",
          "reduceFileSize": "Reduce file size",
          "optimizeScannedPdf": "Optimize Scanned PDF"
        }
      },
      "buttons": {
        "add": "Add >",
        "addPanel": "Add Panel",
        "addInstruction": "Add Instruction",
        "addDivider": "Add Divider",
        "moveUp": "Move Up",
        "moveDown": "Move Down",
        "remove": "Remove"
      },
      "actionSteps": {
        "title": "Action steps to show:",
        "filesToBeProcessed": {
          "title": "Files to be processed",
          "filePlaceholder": "Set current open file as the default"
        }
      }
    }
  },
  "runAction": {
    "Modal": {
      "title": "Run Action",
      "close": "Close",
      "actionList": "Actions List"
    },
    "start": "Start",
    "resume": "Resume",
    "stop": "Stop",
    "done": "Done"
  },
  "manageActions": {
    "Modal": {
      "title": "Manage Actions",
      "close": "Close",
      "selectAnAction": "Select An Action",
      "copy": "Copy",
      "buttons": {
        "edit": "Edit",
        "rename": "Rename",
        "copy": "Copy",
        "moveUp": "Move Up",
        "moveDown": "Move Down",
        "remove": "Remove",
        "import": "Import",
        "export": "Export"
      }
    }
  },
  "continue": {
    "title": "Please read or follow the instructions below:",
    "bodyText": "Please use the tool to finish your task.",
    "okBtnText": "Click to proceed"
  },
  "runActionPanel": {
    "closeAlert": {
      "text": "The action is not complete for this document. Are you sure you want to exit it?"
    }
  }
}